import { WrappedFieldProps } from 'redux-form';
import FormSection from '../../FormSection/FormSection';
import TextField from '@material-ui/core/TextField/TextField';
import * as React from 'react';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { formatFieldValue, getInputAdornment } from '../../../format';
import * as styles from './ViewEditField.css';

interface ViewEditFieldProps {
  type: FieldType;
  fieldFormat?: FieldFormat;
  label: string;
  disabled: boolean;
  options?: Array<{ name: string; value: string }>;
}

const ViewEditField = (props: ViewEditFieldProps & WrappedFieldProps) => (
  <FormSection {...props}>
    {props.disabled ? (
      <span>
        {formatFieldValue(props.input.value, props.type, props.fieldFormat, props.options)}
      </span>
    ) : (
      <>
        {props.options ? (
          <TextField
            select
            {...props.input}
            onChange={(event: any) => props.input.onChange(event.target.value)}
            className={styles.field}
            variant="outlined">
            {props.options.map(opt => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.name}
              </MenuItem>
            ))}
          </TextField>
        ) : (
          <TextField
            {...props.input}
            type={props.type}
            className={styles.field}
            variant="outlined"
            InputProps={getInputAdornment(props.fieldFormat)}
            InputLabelProps={
              props.type === 'date'
                ? {
                    shrink: true
                  }
                : {}
            }
          />
        )}
      </>
    )}
  </FormSection>
);

export default ViewEditField;
